import {
  provideSoftAppsModule,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { default as de } from './i18n/de.json';
import { invoiceLinkRoutes } from './invoice-link.routes';
import { SOFTLINE_PERMISSION_ABAU_INVOICE_LINK } from './invoice-link.shared';

export function provideInvoiceLink() {
  return [
    provideSoftAppsModule(
      {
        name: 'abau-invoice-link',
        title: '#ABAU_INVOICE_LINK.TITLE',
        icon: 'fa-regular fa-link',
        route: '/invoice-link',
        permission: SOFTLINE_PERMISSION_ABAU_INVOICE_LINK,
      },
      withSoftAppsModuleRoutes({ app: invoiceLinkRoutes }),
      withSoftAppsModuleTranslation({ de })
    ),
  ];
}
